import store from '../'

let resource = store.defineResource({
  name: "userAssignments",
  endpoint: "user-assignments",
  relations: {
    hasMany: {
      responses: [
        {
          localField: "responses",
          localKeys: "responseIds"
        },
        {
          localField: "compResponseIds",
          get (Resource, relationDef, instance, origGetter) {
            return _.chain(instance.responses).filter({question: {key: "sbcomp"}}).orderBy("displayOrder").map("id").value()
          }
        },
        {
          localField: "compResponses",
          localKeys: "compResponseIds"
        },
      ],
      reviews: [
        {
          localField: 'reviews',
          localKeys: 'reviewIds'
        },
        {
          localField: 'reviewsGivenIds',
          get (Resource, relationDef, instance, origGetter) {
            return _.chain(instance.reviews).filter({state: 'closed', reviewerUserAssignmentId: instance.id}).map("id").value()
          }
        },
        {
          localField: 'peerReviewsReceivedIds',
          get (Resource, relationDef, instance, origGetter) {
            return _.chain(instance.reviews).filter((x) => x.state === 'closed' && x.revieweeUserAssignmentId === instance.id && !!x.reviewerUserAssignmentId).map("id").value()
          }
        },
        {
          localField: 'reviewsGiven',
          localKeys: 'reviewsGivenIds'
        },
        {
          localField: 'peerReviewsReceived',
          localKeys: 'peerReviewsReceivedIds'
        }
      ],
      annotations: [
        {
          localField: 'annotations',
          localKeys: 'annotationIds'
        },
        {
          localField: 'teacherAnnotations',
          localKeys: 'teacherAnnotationIds'
        }
      ],
      questionGroups: [
        {
          localField: "questionGroupIds",
          get (Resource, relationDef, instance, origGetter) {
            const sortBy = {
              7: 1, // Comp
              10: 2, // Blast
              9: 2, // Write
              11: 3 // QuikPoll
            };
            return _.chain(instance.assignment.questions).map("groupId").uniq().sortBy((id) => { return sortBy[id] }).value()
          }
        },
        {
          localField: "questionGroups",
          localKeys: "questionGroupIds"
        }
      ]
    },
    hasOne: {
      reviews: [
        {
          localField: 'teacherReviewId',
          get (Resource, relationDef, instance, origGetter) {
            return _.chain(instance.reviews).find((review) => { return review.state == 'closed' && !review.reviewerUserAssignmentId }).get("id").value()
          }
        },
        {
          localField: "teacherReview",
          localKey: "teacherReviewId"
        }
      ],
      responses: [
        {
          localField: "blastPromptId",
          get (Resource, relationDef, instance, origGetter) {
            return _.chain(instance.responses).find({question: {key: "sbblast"}}).get("id").value()
          }
        },
        {
          localField: "quikPollId",
          get (Resource, relationDef, instance, origGetter) {
            return _.chain(instance.responses).find({question: {key: "sbpoll"}}).get("id").value()
          }
        },
        {
          localField: "writeResponseId",
          get (Resource, relationDef, instance, origGetter) {
            return _.chain(instance.responses).find({question: {key: "write"}}).get("id").value()
          }
        },
        {
          localField: "reviewQuestionId",
          get (Resource, relationDef, instance, origGetter) {
            return instance.writeResponseId || instance.blastPromptId
          }
        },
        {
          localField: "vocabQuestionId",
          get (Resource, relationDef, instance, origGetter) {
            return _.chain(instance.responses).find({question: {key: "sbvocab"}}).get("id").value()
          }
        },
        {
          localField: "blastPrompt",
          localKey: "blastPromptId"
        },
        {
          localField: "quikPoll",
          localKey: "quikPollId"
        },
        {
          localField: "write",
          localKey: "writeResponseId"
        },
        {
          localField: "reviewQuestion",
          localKey: "reviewQuestionId"
        },
        {
          localField: "vocabQuestion",
          localKey: "vocabQuestionId"
        }
      ]
    },
    belongsTo: {
      assignments: {
        localKey: "assignmentId",
        localField: "assignment"
      }
    }
  },
  computed: {
    dueDate: {
      get () {
        let key = (this.state == 'review') ? 'reviewEndDate' : 'endDate'
        if(this.assignment) {
          return moment(_.get(this, `assignment.${key}`))
        }
      }
    },
    isOpen: {
      get () {
        return this.state === 'open'
      }
    },
    isClosed: {
      get () {
        return this.state === 'closed'
      }
    },
    isReview: {
      get () {
        return this.state === 'review'
      }
    },
    allResponsesComplete: {
      get () {
        return _.every(this.responses, (response) => { return !!response.response })
      }
    },
    assignmentType: (() => {
      const typeLookup = {
        15: 'Read',
        16: 'Blast',
        17: 'Write'
      }
      return {
        get () {
          return typeLookup[_.get(this, 'assignment.typeId')] || null
        }
      }
    })(),
    completionProgress: {
      enumerable: true,
      get () {
        let completed = _.filter(this.responses, (response) => {
          const key = _.get(response, "question.key")
          if(key == 'sbvocab') {
            return _.every(response.response, (r) => { return !!r.answerDefinitionId })
          } else {
            return !!response.response
          }
        }).length
        return (completed / this.responses.length) * 100
      }
    }
  },
  methods: {
    submitAssignment () {
      _.assign(this, {
        state: "pending",
        postDate: moment().toISOString()
      })
      return this.DSSave()
    },
    getNextOpenReview () {
      let review = _.find(this.reviews, { state: "open" })
      return (review) ? _.set(review, "review", "") : null
    }
  }
})

export default resource



// WEBPACK FOOTER //
// ./src/store/models/userAssignments.js